var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viewer-website"},[(_vm.getIsYouTube)?_c('div',{staticClass:"youtube-player",attrs:{"id":"player"}}):_c('iframe',{ref:"iframe",staticClass:"viewer-website__website",attrs:{"src":_vm.getUrl(_vm.src)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3279dd6f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WebViewer.vue
// module id = null
// module chunks = 